import {
  LABOGRUPO_SUCCESS,
  LABOGRUPO_CENTROS,
  LABOGRUPO_LOADING,
  LABOGRUPO_ERROR,
  LABOGRUPO_RESET,
} from "../../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const laboGrupo = (nextStep) => (dispatch) => {
  dispatch({
    type: LABOGRUPO_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`lis/laboratorio/grupoestudio`)
      .then((res) => {
        dispatch({
          type: LABOGRUPO_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABOGRUPO_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, error);
      });
  });
};

export const wsGetLaboCentros = (nextStep) => (dispatch) => {
  dispatch({
    type: LABOGRUPO_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/lis/laboratorio/centros`)
      .then((res) => {
        dispatch({
          type: LABOGRUPO_CENTROS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABOGRUPO_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, error);
      });
  });
};

export const resetLaboGrupo = () => (dispatch) => {
  dispatch({
    type: LABOGRUPO_RESET,
  });
};
